import { Grid, useEventCallback } from '@mui/material';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { ItalianVM } from 'mutation/view-models/registration-beware';
import { FormikErrors, FormikTouched } from 'formik';

interface ItalianProps {
  onChange: (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => void;
  values?: ItalianVM;
  errors?: FormikErrors<ItalianVM>;
  touched?: FormikTouched<ItalianVM>;
}

const ItalianStateComponent = ({
  onChange,
  values,
  errors,
  touched,
}: ItalianProps): React.ReactElement => {
  const onChangeMunicipality = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    onChange('municipality', municipality);
  });

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item xs={12} md={8}>
        <MunicipalityList
          value={values?.municipality || null}
          onChange={onChangeMunicipality}
          label="Comune"
          id="municipalityOfBirth"
          error={touched?.municipality && Boolean(errors?.municipality)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="provinceOfBirth"
          name="provinceOfBirth"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={values?.municipality?.province || ''}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locality"
          name="locality"
          fullWidth
          type="text"
          inputProps={{
            maxLength: '120',
          }}
          variant="outlined"
          value={values?.locality}
          onChange={(event) => onChange('locality', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

ItalianStateComponent.displayName = 'Modal - Italian State component';

const ItalianState = memo(ItalianStateComponent);

export default ItalianState as typeof ItalianStateComponent;
